import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, Injectable, NgModule } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
const _c0 = ["*"];
function ProgressbarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ProgressbarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "bar", 3);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r0.type)("value", ctx_r0._value)("max", ctx_r0.max)("animate", ctx_r0.animate)("striped", ctx_r0.striped);
  }
}
function ProgressbarComponent_ng_template_3_bar_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "bar", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", item_r2.type)("value", item_r2.value)("max", item_r2.max || ctx_r0.max)("animate", ctx_r0.animate)("striped", ctx_r0.striped);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.label);
  }
}
function ProgressbarComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProgressbarComponent_ng_template_3_bar_0_Template, 2, 6, "bar", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r0._values);
  }
}
let BarComponent = /*#__PURE__*/(() => {
  class BarComponent {
    constructor(el, renderer) {
      this.el = el;
      this.renderer = renderer;
      /** maximum total value of progress element */
      this.max = 100;
      /** current value of progress bar */
      this.value = 0;
      /** if `true` changing value of progress bar will be animated */
      this.animate = false;
      /** If `true`, striped classes are applied */
      this.striped = false;
      /** provide one of the four supported contextual classes: `success`, `info`, `warning`, `danger` */
      this.type = 'info';
      this.percent = 100;
    }
    ngOnChanges(changes) {
      if (changes["value"] || changes["max"]) {
        this.percent = 100 * (Number(changes["value"]?.currentValue || this.value) / Number(changes["max"]?.currentValue || this.max || 100));
      }
      if (changes["type"]) {
        this.applyTypeClasses();
      }
    }
    applyTypeClasses() {
      if (this._prevType) {
        const barTypeClass = `progress-bar-${this._prevType}`;
        const bgClass = `bg-${this._prevType}`;
        this.renderer.removeClass(this.el.nativeElement, barTypeClass);
        this.renderer.removeClass(this.el.nativeElement, bgClass);
        this._prevType = void 0;
      }
      if (this.type) {
        const barTypeClass = `progress-bar-${this.type}`;
        const bgClass = `bg-${this.type}`;
        this.renderer.addClass(this.el.nativeElement, barTypeClass);
        this.renderer.addClass(this.el.nativeElement, bgClass);
        this._prevType = this.type;
      }
    }
    static {
      this.ɵfac = function BarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BarComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BarComponent,
        selectors: [["bar"]],
        hostAttrs: ["role", "progressbar", "aria-valuemin", "0"],
        hostVars: 13,
        hostBindings: function BarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-valuenow", ctx.value)("aria-valuetext", ctx.percent ? ctx.percent.toFixed(0) + "%" : "")("aria-valuemax", ctx.max);
            i0.ɵɵstyleProp("height", "100", "%")("width", ctx.percent, "%");
            i0.ɵɵclassProp("progress-bar", true)("progress-bar-animated", ctx.animate)("progress-bar-striped", ctx.striped);
          }
        },
        inputs: {
          max: "max",
          value: "value",
          animate: "animate",
          striped: "striped",
          type: "type"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function BarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return BarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProgressbarConfig = /*#__PURE__*/(() => {
  class ProgressbarConfig {
    constructor() {
      /** if `true` changing value of progress bar will be animated */
      this.animate = false;
      /** maximum total value of progress element */
      this.max = 100;
    }
    static {
      this.ɵfac = function ProgressbarConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProgressbarConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProgressbarConfig,
        factory: ProgressbarConfig.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ProgressbarConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProgressbarComponent = /*#__PURE__*/(() => {
  class ProgressbarComponent {
    /** current value of progress bar. Could be a number or array of objects
     * like {"value":15,"type":"info","label":"15 %"}
     */
    set value(value) {
      this.isStacked = Array.isArray(value);
      if (typeof value === 'number') {
        this._value = value;
        this._values = void 0;
      } else {
        this._value = void 0;
        this._values = value;
      }
    }
    constructor(config) {
      /** maximum total value of progress element */
      this.max = 100;
      /** if `true` changing value of progress bar will be animated */
      this.animate = false;
      /** If `true`, striped classes are applied */
      this.striped = false;
      this.isStacked = false;
      this._value = 0;
      Object.assign(this, config);
    }
    static {
      this.ɵfac = function ProgressbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProgressbarComponent)(i0.ɵɵdirectiveInject(ProgressbarConfig));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProgressbarComponent,
        selectors: [["progressbar"]],
        hostVars: 3,
        hostBindings: function ProgressbarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("max", ctx.max);
            i0.ɵɵclassProp("progress", true);
          }
        },
        inputs: {
          max: "max",
          animate: "animate",
          striped: "striped",
          type: "type",
          value: "value"
        },
        ngContentSelectors: _c0,
        decls: 5,
        vars: 3,
        consts: [["NotStacked", ""], ["Stacked", ""], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "type", "value", "max", "animate", "striped"], [3, "type", "value", "max", "animate", "striped", 4, "ngFor", "ngForOf"]],
        template: function ProgressbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ProgressbarComponent_ng_container_0_Template, 1, 0, "ng-container", 2)(1, ProgressbarComponent_ng_template_1_Template, 2, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, ProgressbarComponent_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const NotStacked_r3 = i0.ɵɵreference(2);
            const Stacked_r4 = i0.ɵɵreference(4);
            i0.ɵɵproperty("ngIf", !ctx.isStacked)("ngIfThen", NotStacked_r3)("ngIfElse", Stacked_r4);
          }
        },
        dependencies: [NgIf, BarComponent, NgFor],
        styles: ["[_nghost-%COMP%]{width:100%;display:flex}"],
        changeDetection: 0
      });
    }
  }
  return ProgressbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProgressbarModule = /*#__PURE__*/(() => {
  class ProgressbarModule {
    // @deprecated method not required anymore, will be deleted in v19.0.0
    static forRoot() {
      return {
        ngModule: ProgressbarModule,
        providers: []
      };
    }
    static {
      this.ɵfac = function ProgressbarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProgressbarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ProgressbarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return ProgressbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BarComponent, ProgressbarComponent, ProgressbarConfig, ProgressbarModule };
